export function addCurrent(role) {
    return {
        type: 'ADD_CURRENT',
        role,
    }
}
